/** API base 常量（独立模块，避免 client 与 auth 循环依赖） */
export const API_BASE: string = import.meta.env.VITE_API_BASE_URL || '/api/v1'
export const API_V2_BASE: string = import.meta.env.VITE_API_V2_BASE_URL || '/api/v2'
